import React, { FC, useEffect, useRef, useState } from 'react';
import Script from 'next/script';
import styled from '@emotion/styled';
import { useBasket } from '~/store';
import { IContentSpot } from '$models';
import { SpotLayout } from '../components/spot-layout';
import { IPaperProduct, IPaperWindow } from '$models/ipaper-types';

export type IPaperSpotProps = {
    catalogUrl: string;
    enableAddToBasket: boolean;
} & IContentSpot;

export const IPaperSpot: FC<IPaperSpotProps> = (props: IPaperSpotProps) => {
    const { catalogUrl, enableAddToBasket } = props;
    const { addToBasket } = useBasket();
    const iframeId = Math.random().toString(36).substring(7);
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [iframeReady, setIframeReady] = useState(false);

    useEffect(() => {
        if (iframeReady && iframeRef?.current && (scriptLoaded || (window as IPaperWindow)?.iPaperJsApi)) {
            const myFlipbookInstance = (window as IPaperWindow)?.iPaperJsApi(iframeRef.current, 3);
            myFlipbookInstance.basket.onProductAdded((product: IPaperProduct) => {
                const { productId, quantity } = product;
                if (enableAddToBasket && productId) {
                    addToBasket(productId, quantity || 1);
                }
            });
        }
    }, [iframeRef?.current, (window as IPaperWindow)?.iPaperJsApi, iframeReady, enableAddToBasket]);

    // eslint-disable-next-line jsx-a11y/iframe-has-title
    return (
        <>
            {/* <IPaperScript /> */}
            <SpotLayout width="full" ignoreVisibilityClass eagerLoad={props.eagerLoad}>
                {!!catalogUrl && (
                    <>
                        <Script
                            id="ipaperv3"
                            src="https://cdn.ipaper.io/flipbooks/api/v3/latest.js"
                            onLoad={() => setScriptLoaded(true)}
                        />
                        <IFrameWrapper>
                            <StyledIframe
                                ref={iframeRef}
                                id={iframeId}
                                scrolling="no"
                                frameBorder="0"
                                src={catalogUrl + '?DisableScrollZoom=true'}
                                data-ipaper
                                onLoad={() => setIframeReady(true)}
                            />
                        </IFrameWrapper>
                    </>
                )}
            </SpotLayout>
        </>
    );
    //we always disable scroll zoom for improved UX
};

const StyledIframe = styled.iframe({
    width: '100%',
    height: '70vh',
});

const IFrameWrapper = styled.div(({ theme }) => ({
    padding: `0 ${theme.space[3]}`,
}));
